
import CpntBlocPresentationDetail from "../../components/CpntBlocPresentationDetail";
import { ContactSujetIds } from "../../config/helpers";
import img_actualisation_referencement_1 from "../../images/presentation/actualisation_referencement_1.jpg"
import "./PagePresentation.scss"


const description1 =
  <>
  <p>
Avec le temps, les fiches de vos ouvrages peuvent devenir obsolètes, affichant des informations incomplètes ou mal structurées, pouvant nuire à votre visibilité et à la pertinence de votre référencement.
</p>
Nous vous proposons d&apos;actualiser et d&apos;optimiser vos fiches bibliographiques en quelques étapes simples :
<ul>
<li><b>Un diagnostic précis</b> : Nous analysons la notice existante de votre ouvrage afin d&apos;identifier les éléments à améliorer ou à mettre à jour</li>
<li><b>Une réécriture optimisée</b> : Nous reconstruisons votre fiche selon les standards actuels, en intégrant une structure claire et cohérente</li>
<li><b>Un référencement amélioré</b> : Grâce à une notice modernisée, votre ouvrage bénéficie d&apos;une meilleure visibilité sur les plateformes de vente et les bases de données professionnelles</li>
</ul>
</>
;

const description2 =
<>
  <div className="mt-4">
    <p className="text-md-start text-justify">
        <u>Comment cela fonctionne ?</u><br/><br/>
        <b>Envoyez-nous un ouvrage</b> : Nous étudions sa notice actuelle et relevons les points à améliorer.<br/><br/>
        <b>Mise à jour complète</b> : Nous révisons entièrement la notice en intégrant les nouvelles normes et données manquantes grâce au contrôle livre en main réalisé par nos catalogueurs expérimentés.<br/><br/>
        <b>Gagnez en clarté, en qualité et en impact ! Confiez-nous la mise à jour de vos notices et assurez à vos ouvrages la meilleure visibilité possible</b>.
    </p>
  </div>
</>
;


const PagePresentation_ActualisationReferencement = () => {

   return (
    <>
    <div className="row pt-3 pb-5">
      <div className="col col-md-10 offset-md-1 col-12 ">
        <div className="titre titre-Presentation text-center">Actualisation du référencement</div>
      </div>
    </div>
        <CpntBlocPresentationDetail
          description1={description1}
        description2={description2}
          img_rond={img_actualisation_referencement_1}
          linktext="Nous contacter"
          contactsujet={ContactSujetIds.ActualisationDuReferencement}
        />
      </>
  );
};

export default PagePresentation_ActualisationReferencement;
